import get from 'lodash/get';

import { AppRootState } from '../../../../../../../../store/models/app-state.model';
import { REVIEWS } from '../../../../../../../../store/utils/files-names';
import { ReviewsHeaderAndPaginationFilters } from '../../../../thunks/models/reviews-header-and-pagination-filters.model';

export const getReviewsFilters = (
  state: AppRootState
): ReviewsHeaderAndPaginationFilters => get(state, REVIEWS).filters;
